import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class FilterLineupsByPlayer extends Component {
    onCheck(isChecked) {
        const {player} = this.props;

        this.props.dispatch(
            Action.do('filterLineupsByCheckedPlayer', {
                playerId: player.getId(),
                isChecked,
            }),
        );
    }

    isPlayerChecked() {
        const {player, filterLineupsByPlayer} = this.props;

        return filterLineupsByPlayer.isPlayerChecked(player.getId());
    }

    canComponentBeRendered() {
        const {lineupPlayerMap} = this.props;

        return lineupPlayerMap.hasMap();
    }

    getClassNames(isPlayerChecked, isButtonDisabled) {
        const classNames = ['search-btn', this.props.className || ''];

        if (isPlayerChecked && !isButtonDisabled) {
            classNames.push('active');
        }

        return classNames;
    }

    getTitle(isChecked) {
        return isChecked ? 'Search enabled' : 'Search disabled';
    }

    isButtonDisabled() {
        const {player} = this.props;

        return player.usedLineupsCount <= 0;
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const isPlayerChecked = this.isPlayerChecked();
        const isButtonDisabled = this.isButtonDisabled();

        const classNames = this.getClassNames(isPlayerChecked, isButtonDisabled);
        const title = this.getTitle(isPlayerChecked);

        return (
            <button
                type="button"
                className={classNames.join(' ')}
                onClick={() => ::this.onCheck(!isPlayerChecked)}
                title={title}
                disabled={isButtonDisabled}
            >
                {title}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {filterLineupsByPlayer, lineupPlayerMap} = state;

    return {
        filterLineupsByPlayer,
        lineupPlayerMap,
    };
}

export default connect(mapStatesToProps)(FilterLineupsByPlayer);

export {FilterLineupsByPlayer};
